import { AfterViewInit, Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WindowExtension } from './rokezzz/window/api/window-extension';
import { RokezzzVisibilityService } from './rokezzz/window/services/visibility.service';
import { RokezzzWindowResizeService } from './rokezzz/window/services/window-resize.service';
import { RokezzzWindowScrollService } from './rokezzz/window/services/window-scroll.service';
import { RokezzzWindowService } from './rokezzz/window/services/window.service';
import { globals } from './globals';
import { RokezzzLocalStorageService } from './rokezzz/local-storage/services/local-storage.service';
import { RokezzzLoginService } from './rokezzz/user/services/login.service';
import { RokezzzNotificationComponent } from './rokezzz/notification/components/notification/notification.component';
import { RokezzzImageDataService } from './rokezzz/file-upload/services/image-data.service';
import { RokezzzPlatformService } from './rokezzz/platform/services/platform.service';
import { RokezzzPageLoaderComponent } from './rokezzz/page-loader/components/page-loader/page-loader.component';
import { moduleConfig } from './core/models/module-config';
import { RokezzzSettingDataService } from './rokezzz/setting/services/setting-data.service';
import { RokezzzGtagService } from './rokezzz/gtag/services/gtag.service';

@Component({
    selector: '#app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [
        RouterOutlet,
        RokezzzNotificationComponent,
        RokezzzPageLoaderComponent
    ],
})
export class AppComponent implements AfterViewInit {
    private windowExtension: WindowExtension;
    private document: Document;

    public constructor(
        private readonly localStorageService: RokezzzLocalStorageService,
        private readonly windowService: RokezzzWindowService,
        private readonly windowScrollService: RokezzzWindowScrollService,
        private readonly windowResizeService: RokezzzWindowResizeService,
        private readonly visibilityService: RokezzzVisibilityService,
        private readonly loginService: RokezzzLoginService,
        private readonly rokezzzImageDataService: RokezzzImageDataService,
        private readonly rokezzzPlatformService: RokezzzPlatformService,
        private readonly settingDataService: RokezzzSettingDataService,
        private readonly gTagService: RokezzzGtagService
    ) {
        globals.localStorageService = localStorageService;
        this.windowExtension = this.windowService.getWindowExtension();
        this.document = this.windowService.getDocument();

        if (this.windowExtension.loadingInterval) {
            window.clearInterval(this.windowExtension.loadingInterval);
        }
    }

    @HostListener('window:visibilitychange', ['$event'])
    public onWindowVisible(): void {
        this.visibilityService.setWindowVisible(!this.document.hidden);
    }

    @HostListener('window:scroll', ['$event'])
    public onScroll(): void {
        this.windowScrollService.setScroll(this.windowExtension.scrollY);
    }

    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.windowScrollService.setScroll(this.windowExtension.scrollY);
        this.windowResizeService.setSize({
            width: this.windowExtension.innerWidth,
            height: this.windowExtension.innerHeight
        });
    }

    public ngAfterViewInit(): void {
        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            this.windowScrollService.setScroll(this.windowExtension.scrollY);
            this.windowResizeService.setSize({
                width: this.windowExtension.innerWidth,
                height: this.windowExtension.innerHeight
            });

            if (moduleConfig.isAdminEnabled) {
                this.loginService.init();
            }

            if (
                moduleConfig.isProductEnabled ||
                moduleConfig.isSettingsEnabled ||
                moduleConfig.isBlogEnabled
            ) {
                this.rokezzzImageDataService.refresh();
            }

            if (moduleConfig.isSettingsEnabled) {
                this.settingDataService.init();
            }

            this.gTagService.init();
        }
    }
}
